import { useQuery } from '@tanstack/react-query';
import {
  GetOilMerchantUserEntity,
  UserWalletManageService,
} from 'services/openapi';

import { UserServiceQueryKeys } from '../constants';

export const useGetUserMerchantOilInfoQuery = (options?: {
  enabled?: boolean;
}) => {
  const queryKey = [UserServiceQueryKeys.GET_MERCHANT_OIL_LIST];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetOilMerchantUserEntity, Error>({
    queryKey,
    queryFn: () =>
      UserWalletManageService.userManageControllerGetAllMerchantOilUsers(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: options?.enabled ?? true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
